jQuery(document).ready(function($) {
    //checkCookie();

    if ( $( 'body' ).hasClass( "page-template-ajanvaraus" ) ) {
        $('#reservation-form-holder').show();
    }
    var showform = getUrlParameter('f');
    if(showform==1){
        $('#reservation-form-holder').show();
    }

    $('#open-reservation a').on( "click", function(e) {
        e.preventDefault();
        $('#quick-reservation-form-holder').slideToggle( "fast" );
    });

    $('.btn__show-garages').on( "click", function(e) {
        e.preventDefault();
        $('.cities-list').slideToggle;
    });

    $('.show-reservation-btn').on( "click", function(e) {
        e.preventDefault();
        showReservation()
    });

    $("#ajax_posts_wrap").on("click", ".show-reservation-btn", function(e) {
        e.preventDefault();
        showReservation()
    } );

    $(".modalinit").click(function(e){
        e.preventDefault();
        $('#np2020modal').foundation('close');
        showReservation()
    });

    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires="+d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }
    function getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for(var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }
    function checkCookie() {
        var modalShown = getCookie("kevat10modal");
        if (modalShown != "yes") {
            $('#np2020modal').foundation('open');
        }
    }
    $('#np2020modal').on('closed.zf.reveal', function () {
        var modal = $(this);
        setCookie("kevat10modal", "yes", 1);
    });
    $('a.closemodalbtn').on('click', function() {
        $('#np2020modal').foundation('close');
    });

    function showReservation(){
        $('#reservation-form-holder').slideToggle();
        $('html, body').animate({
            scrollTop: $('body').offset().top
        }, 500);
    }

    function checkposition() {
        if($(document).scrollTop() > 100){
            $('#top-bar-menu').addClass('menu-bar__small');
        }
        else{
            $('#top-bar-menu').removeClass('menu-bar__small');
        }
    }
    //window.addEventListener('scroll', debounce(checkposition));
    window.addEventListener('scroll', checkposition);

    function debounce(func, wait = 1, immediate = true) {
		var timeout;
		return function() {
		  var context = this, args = arguments;
		  var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		  };
		  var callNow = immediate && !timeout;
		  clearTimeout(timeout);
		  timeout = setTimeout(later, wait);
		  if (callNow) func.apply(context, args);
		}
    }

    // check for parameter
    function getUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    };


    // Select all links with hashes
    //$('a[href*="#"]')
    $('a.scroll-to-anchor')
    // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function(event) {
    // On-page links
    if (
        location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
        &&
        location.hostname == this.hostname
    ) {
        // Figure out element to scroll to
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        // Does a scroll target exist?
        if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $('html, body').animate({
            scrollTop: target.offset().top
        }, 1000, function() {
            // Callback after animation
            // Must change focus!
            var $target = $(target);
            $target.focus();
            if ($target.is(":focus")) { // Checking if the target was focused
            return false;
            } else {
            $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
            $target.focus(); // Set focus again
            };
        });
        }
    }
    });

});